import i18n from "../plugins/i18n";
import _ from "lodash";
import messagesToast from "./messageToasts";
import moment from "moment";
import store from "../store";
import Vue from "vue";

export function random(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}
/**
 * @description
 * @export
 * @param {*} num
 * @returns
 */
export function doubleDigit(num) {
  return num < 10 ? "0" + num : num;
}

export function readACL(unitID) {
  const foundAccess = _.find(JSON.parse(localStorage.getItem("acl")), function(
    o
  ) {
    return o.uID === unitID;
  });
  return foundAccess;
}

export function checkChildrenACL(menu) {
  const submenus = [];
  _.forEach(menu, function(submenu) {
    const subMenuRule = readACL(submenu.uID);
    if (subMenuRule && subMenuRule.canAccess === 1) {
      submenus.push(submenu);
    }
  });
  return submenus;
}

export function checkAccessControl(accessID) {
  let checkData = JSON.parse(localStorage.getItem("access_control"));
  const foundAccess = checkData ? checkData.hasOwnProperty(accessID) : true;
  if (foundAccess) {
    return false;
  } else {
    return true;
  }
}

export function checkRouterAcl() {
  let routerControl = localStorage.getItem("access_control");
  return JSON.parse(routerControl);
}

export function readDisplayAccess(unitID) {
  const foundAccess = _.find(JSON.parse(localStorage.getItem("acl")), function(
    o
  ) {
    return o.uID === unitID;
  });
  if (foundAccess) {
    return foundAccess.canAccess === 1 ? true : false;
  } else {
    return false;
  }
}

export function getDateHourMinute(date) {
  return (
    date.getFullYear() +
    "-" +
    doubleDigit(date.getMonth() + 1) +
    "-" +
    doubleDigit(date.getDate()) +
    " " +
    doubleDigit(date.getHours()) +
    ":" +
    doubleDigit(date.getMinutes()) +
    ":" +
    doubleDigit(date.getSeconds())
  );
}

export function dateOrTime(dateString, type) {
  /* check for ie 11 */
  dateString = ieDateTimeFormat(dateString);
  const date = new Date(dateString);
  switch (type) {
    case "date":
      return (
        date.getFullYear() +
        "-" +
        doubleDigit(date.getMonth() + 1) +
        "-" +
        doubleDigit(date.getDate())
      );
    case "hourMinute":
      return (
        doubleDigit(date.getHours()) + ":" + doubleDigit(date.getMinutes())
      );
    case "month": {
      return date.getMonth() + 1;
    }
    case "year": {
      return date.getFullYear();
    }
    case "hours": {
      return doubleDigit(date.getHours());
    }
    case "minutes": {
      return doubleDigit(date.getMinutes());
    }
    default:
      return "";
  }
}

export function timeDiff(start_time, end_time) {
  const startTime = new Date(start_time);
  const endTime = new Date(end_time);
  var diff = Math.abs(startTime - endTime);
  return Math.floor(diff / 1000 / 60) + i18n.t("MINUTE");
}

/**
 * Randomize array element order in-place.
 * Using Durstenfeld shuffle algorithm.
 */
export const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1));
    let temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
};

export function getLangField(field) {
  let optionsNameField = i18n.locale === "ja" ? field + "_jp" : field + "_en";
  return optionsNameField;
}

export function getObjectfromArray(id, dataArray, key) {
  let obj = dataArray.find((data) => id === data[key]);
  return obj;
}

export function unlinkReactivityStore(data) {
  return JSON.parse(JSON.stringify(data));
}

export default {
  showCancelButton: false,
  confirmButtonText: i18n.t("CLOSE"),
  cancelButtonText: i18n.t("CANCEL"),
  confirmButtonColor: "#062854",
  cancelButtonColor: "#aaa",
  buttonsStyling: true,
  customClass: {
    confirmButton: "btn btn-primary px-4 mr-2",
    cancelButton: "btn  px-4 mr-2",
  },
  width: 400,
  padding: "3em",
};

export function authHeaders() {
  return {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
    Accept: "application/json",
    "Content-Type": "multipart/form-data",
  };
}

export function daysDiff(start_time, end_time) {
  let startTime = new Date(start_time);
  let endTime = new Date(end_time);
  if (startTime instanceof Date && !isNaN(startTime)) {
    //eslint handling
  } else {
    /** IE supported date */
    const dMY = start_time.split(" ");
    startTime = new Date(
      Number(dMY[0].split("-")[0]),
      Number(dMY[0].split("-")[1]) - 1,
      Number(dMY[0].split("-")[2]),
      Number(dMY[1].split(":")[0]),
      Number(dMY[1].split(":")[1])
    );

    const endDMY = end_time.split(" ");
    endTime = new Date(
      Number(endDMY[0].split("-")[0]),
      Number(endDMY[0].split("-")[1]) - 1,
      Number(endDMY[0].split("-")[2]),
      Number(endDMY[1].split(":")[0]),
      Number(endDMY[1].split(":")[1])
    );
  }
  // To calculate the time difference of two dates
  var Difference_In_Time = endTime.getTime() - startTime.getTime();

  // To calculate the no. of days between two dates
  var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
  return Math.floor(Difference_In_Days);
}
export function getSubString(str, lengthToCut) {
  return str.substring(0, str.length - lengthToCut);
}

export function getCustomSubString(str) {
  let arr = str.split(":");

  let date = new Date();

  date.setHours(arr[0]);
  date.setMinutes(arr[1]);

  return Math.abs(date.getTime());
}

export function stringIfNull(str) {
  return str === null ? "" : str;
}

export function addDays(str, days) {
  var date = new Date(str);
  date.setDate(date.getDate() + days);
  return date.toISOString();
}

export function returnObject(array, value) {
  let object = array.find((arr) => arr.value === value);

  return object.text;
}

export function timeList(type) {
  var ampm = ["AM", "PM"];
  var times = [];
  var halfHours = ["00", "30"];
  var timeArray1 = [7, 0];
  var timeArray2 = [12, 7];
  let timeArrayJP1 = [7];
  let timeArrayJP2 = [19];
  switch (type) {
    case "half":
      for (let ap = 0; ap < 2; ap++) {
        for (let i = timeArray1[ap]; i < timeArray2[ap]; i++) {
          for (let j = 0; j < halfHours.length; j++) {
            let time = "";
            if (i === 0) {
              time = "12" + ":" + halfHours[j] + ampm[ap];
            } else {
              time = i + ":" + halfHours[j] + ampm[ap];
            }

            times.push(time);
          }
        }
      }

      return times;
    case "halfJP":
      for (let ap = 0; ap < 1; ap++) {
        for (let i = timeArrayJP1[ap]; i < timeArrayJP2[ap]; i++) {
          for (let j = 0; j < halfHours.length; j++) {
            let time = "";
            if (i <= 9) {
              time = "0" + i + "時" + halfHours[j] + "分";
            } else {
              time = i + "時" + halfHours[j] + "分";
            }
            times.push(time);
          }
        }
      }

      return times;
    case "five":
      var fiveMinutesDiff = [
        "00",
        "05",
        "10",
        "15",
        "20",
        "25",
        "30",
        "35",
        "40",
        "45",
        "50",
        "55",
      ];
      for (let ap = 0; ap < 2; ap++) {
        for (let i = timeArray1[ap]; i < timeArray2[ap]; i++) {
          for (let j = 0; j < fiveMinutesDiff.length; j++) {
            let time = "";
            if (i === 0) {
              time = "12" + ":" + fiveMinutesDiff[j] + ampm[ap];
            } else {
              time = i + ":" + fiveMinutesDiff[j] + ampm[ap];
            }

            // if (i < 10 && i != 0) {
            //   time = "0" + time;
            // }
            times.push(time);
          }
        }
      }
      return times;
    case "fivejp":
      var fiveMinutesDiffJP = [
        "00",
        "05",
        "10",
        "15",
        "20",
        "25",
        "30",
        "35",
        "40",
        "45",
        "50",
        "55",
      ];
      for (let ap = 0; ap < 1; ap++) {
        for (let i = timeArrayJP1[ap]; i < timeArrayJP2[ap]; i++) {
          for (let j = 0; j < fiveMinutesDiffJP.length; j++) {
            let time = "";
            if (i <= 9) {
              time = "0" + i + "時" + fiveMinutesDiffJP[j] + "分";
            } else {
              time = i + "時" + fiveMinutesDiffJP[j] + "分";
            }
            times.push(time);
          }
        }
      }
      return times;
    case "half-concat": {
      let count = 12;
      let number = 7;
      let strOrNumber = "";
      for (let i = 0; i <= count; i++) {
        for (let j = 0; j < halfHours.length; j++) {
          let time = "";
          if (String(number).length === 1) {
            number = "0" + number;
          }
          time = number + ":" + halfHours[j] + "-";
          if (j === 0) {
            if (typeof number === "string" && parseInt(number) != 9) {
              strOrNumber = "0";
            } else {
              strOrNumber = 0;
            }
            let thirty = number + ":" + halfHours[j + 1];
            time += thirty;
            times.push(time);
            time = thirty + "-";

            time += strOrNumber + (parseInt(number) + 1) + ":" + halfHours[j];
            times.push(time);
          }
        }
        number++;
      }
      return times;
    }
    case "half-concatampm": {
      let count = 12;
      let number = 7;

      for (let i = 0; i <= count; i++) {
        for (let j = 0; j < halfHours.length; j++) {
          let time = "";
          // append am pm
          if (number < 12) {
            time = number + ":" + halfHours[j] + ampm[j] + "-";
          } else {
            time = (number % 12 || 12) + ":" + halfHours[j] + ampm[j + 1] + "-";
          }
          if (j === 0) {
            let thirty;
            // append am pm
            if (number < 12) {
              thirty = number + ":" + halfHours[j + 1] + ampm[j];
            } else {
              thirty =
                (number % 12 || 12) + ":" + halfHours[j + 1] + ampm[j + 1];
            }

            time += thirty;
            times.push(time);
            time = thirty + "-";
            let tempNumber = number + 1;
            // append am pm
            if (tempNumber < 12) {
              time += number + 1 + ":" + halfHours[j] + ampm[j];
            } else {
              time +=
                ((number + 1) % 12 || 12) + ":" + halfHours[j] + ampm[j + 1];
            }

            times.push(time);
          }
        }
        number++;
      }
      return times;
    }
    case "half-concatjp": {
      let count = 12;
      let number = 7;
      let strOrNumber = "";
      for (let i = 0; i <= count; i++) {
        for (let j = 0; j < halfHours.length; j++) {
          let time = "";
          if (String(number).length === 1) {
            number = "0" + number;
          }
          time = number + "時" + halfHours[j] + "分" + " ~ ";
          if (j === 0) {
            if (typeof number === "string" && parseInt(number) != 9) {
              strOrNumber = "0";
            } else {
              strOrNumber = 0;
            }
            let thirty = number + "時" + halfHours[j + 1] + "分";
            time += thirty;
            times.push(time);
            time = thirty + " ~ ";

            time +=
              strOrNumber + (parseInt(number) + 1) + "時" + halfHours[j] + "分";
            times.push(time);
          }
        }
        number++;
      }
      return times;
    }
    default:
      return [];
  }
}
export function convertTo24Hour(time) {
  var hours = parseInt(time.substr(0, 2));
  if (time.indexOf("AM") != -1 && hours == 12) {
    time = time.replace("12", "00");
  }
  if (time.indexOf("PM") != -1 && hours < 12) {
    time = time.replace(hours, hours + 12);
  }

  time = time.replace(/(AM|PM)/, "");

  return time;
}

export function convertTo24HourForJP(time) {
  time = time.replace(/(分)/, "");
  time = time.replace(/(時)/, ":");
  return time;
}

export function formatAMPM(dateString) {
  let date = new Date(dateString);
  if (date instanceof Date && !isNaN(date)) {
    // es lint handling
  } else {
    const dMY = dateString.split(" ");
    date = new Date(
      Number(dMY[0].split("-")[0]),
      Number(dMY[0].split("-")[1]) - 1,
      Number(dMY[0].split("-")[2]),
      Number(dMY[1].split(":")[0]),
      Number(dMY[1].split(":")[1])
    );
  }
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var strTime = hours + ":" + minutes + ampm;
  return strTime;
}

export function format24HourMinutes(dateString) {
  let date = new Date(dateString);
  if (date instanceof Date && !isNaN(date)) {
    // es lint handling
  } else {
    const dMY = dateString.split(" ");
    date = new Date(
      Number(dMY[0].split("-")[0]),
      Number(dMY[0].split("-")[1]) - 1,
      Number(dMY[0].split("-")[2]),
      Number(dMY[1].split(":")[0]),
      Number(dMY[1].split(":")[1])
    );
  }
  var hours = date.getHours();
  var minutes = date.getMinutes();
  if (minutes == 0) {
    minutes = "00";
  }
  let strTime = "";
  if (hours <= 9) {
    strTime = "0" + hours + ":" + minutes;
  } else {
    strTime = hours + ":" + minutes;
  }

  return strTime;
}
export function clearLocalStorage(key) {
  switch (key) {
    case "/registration":
      localStorage.removeItem("role");
      localStorage.removeItem("token");
      localStorage.removeItem("userName");
      localStorage.removeItem("acl");
      break;
    case "userEditReservation":
      localStorage.setItem("role", "USER");
      break;
    default:
      localStorage.removeItem(key);
      break;
  }
}

export function buildHierarchy(arry) {
  var roots = [],
    children = {};

  // find the top level nodes and hash the children based on parent
  for (var i = 0, len = arry.length; i < len; ++i) {
    var item = arry[i],
      p = item.parent,
      target = !p ? roots : children[p] || (children[p] = []);

    target.push({
      id: item.id,
      data: item,
      text: item[getLangField("feature")],
      state: {
        checked: item.canAccess === 1 ? true : false,
        disabled: item.uID === "A001" ? true : false,
      },
    });
  }

  // function to recursively build the tree
  var findChildren = function(parent) {
    if (children[parent.data.uID]) {
      parent.children = children[parent.data.uID];
      for (var j = 0, len2 = parent.children.length; j < len2; ++j) {
        findChildren(parent.children[j]);
      }
    }
  };

  // enumerate through to handle the case where there are multiple roots
  for (var m = 0, len1 = roots.length; m < len1; ++m) {
    findChildren(roots[m]);
  }

  return roots;
}

export function validateDateBetweenTwoDates(fromDate, toDate, givenDate) {
  logValuesInSession("valid_date", { fromDate, toDate, givenDate });

  return (
    getvalidDate(givenDate) <= getvalidDate(toDate) &&
    getvalidDate(givenDate) >= getvalidDate(fromDate)
  );
}

function getvalidDate(d) {
  return new Date(d);
}
/**
 *
 *
 * @export
 * @param {import("bootstrap-vue").BvToast} toast
 * @param {show bv toast} response
 * @param { string } title
 */
export function showErrorMessage(toast, response, title) {
  if (response.code === 422) {
    messagesToast.errorFailure(toast, response, title);
  } else {
    messagesToast.infoMessage(toast, response.message, title);
  }
}

export function ieDateTimeFormat(dateString) {
  let usa = window.navigator.userAgent;
  let trident = usa.indexOf("Trident/");
  if (trident > 0) {
    dateString = moment(dateString).format("YYYY-MM-DDTHH:MM:SS");
    dateString = String(dateString);
    return dateString;
  } else {
    return dateString;
  }
}

export function checkAdminLogin() {
  let admin = localStorage.getItem("role");

  if (admin === "ADMIN") {
    return true;
  }

  return false;
}

export function checkUserHasCourseAssigned(course_id) {
  let userRoleCourseDetails = store.getters.getLoginUsersCourseIds;

  if (userRoleCourseDetails["role_id"] == 1) {
    return true;
  } else {
    return userRoleCourseDetails["course_ids"].includes(course_id);
  }
}

export function isSuperAdmin() {
  let userRoleCourseDetails = store.getters.getLoginUsersCourseIds;
  return userRoleCourseDetails["role_id"] == 1 ? true : false;
}

export function setRoleUser() {
  if (localStorage.getItem("role") === "ADMIN") {
    localStorage.setItem("role", "USER");
  }
}

export function checkTokenExists() {
  return localStorage.getItem("token") != undefined ? true : false;
}

export function redirectToAdminDashBoard(route, router, swal) {
  if (route.path.indexOf("user") != -1) {
    swal({
      type: "warning",
      text: i18n.t("LOGGEDINASADMIN"),
    }).then((res) => {
      if (res) {
        router.push("/admin/dashboard").then(() => {
          router.go();
        });
      }
    });
  } else if (route.path == "/registration") {
    swal({
      type: "warning",
      text: i18n.t("LOGGEDINASADMIN"),
    }).then((res) => {
      if (res) {
        router.push("/admin/dashboard").then(() => {
          router.go();
        });
      }
    });
  }
}

export function logValuesInSession(variable_name, value) {
  sessionStorage.setItem(variable_name, value);
}

export function toLocaleString(date) {
  let localdate = moment(date)
    .utc(date)
    .format("YYYY-MM-DD HH:mm:ss");
  /* uncomment below line to get am pm format */
  //localdate  = moment().utc(date).format('YYYY-MM-DD LT');

  return localdate;
}

export function getMoment() {
  return moment;
}

export function japaneseDate(date) {
  let dateString = ieDateTimeFormat(date);
  return moment(new Date(dateString)).format("YYYY年MM月DD日");
}

export function japaneseTimeAMPM(dateString) {
  let date = new Date(dateString);
  if (date instanceof Date && !isNaN(date)) {
    // es lint handling
  } else {
    const dMY = dateString.split(" ");
    date = new Date(
      Number(dMY[0].split("-")[0]),
      Number(dMY[0].split("-")[1]) - 1,
      Number(dMY[0].split("-")[2]),
      Number(dMY[1].split(":")[0]),
      Number(dMY[1].split(":")[1])
    );
  }
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? "午後" : "午前";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var strTime = hours + ":" + minutes + ampm;
  return strTime;
}
export function japaneseTimeHourMinutes(dateString) {
  let date = new Date(dateString);
  if (date instanceof Date && !isNaN(date)) {
    // es lint handling
  } else {
    const dMY = dateString.split(" ");
    date = new Date(
      Number(dMY[0].split("-")[0]),
      Number(dMY[0].split("-")[1]) - 1,
      Number(dMY[0].split("-")[2]),
      Number(dMY[1].split(":")[0]),
      Number(dMY[1].split(":")[1])
    );
  }
  var hours = date.getHours();
  var minutes = date.getMinutes();
  if (minutes == 0) {
    minutes = "00";
  }
  let strTime = "";
  if (hours <= 9) {
    strTime = "0" + hours + "時" + minutes + "分";
  } else {
    strTime = hours + "時" + minutes + "分";
  }

  return strTime;
}

export function japaneseTimeHourMinutesForCsv(time) {
  const dMY = time.split(":");
  let strTime = "";
  strTime = dMY[0] + "時" + dMY[1] + "分";
  return strTime;
}
export function getsubstringname(string) {
  return `${string.substring(0, 12)}...`;
}

export function getLocalStorageItem(key) {
  let data = localStorage.getItem(key);
  return JSON.parse(data);
}

export function setLocalStorageItem(key, payload) {
  return localStorage.setItem(key, JSON.stringify(payload));
}

export function detectIEBrowser() {
  let ua = window.navigator.userAgent;
  let isIE = /MSIE|Trident/.test(ua);

  if (isIE) {
    return true;
  } else {
    return false;
  }
}

export function getGroupSizeArray() {
  if (checkAdminLogin()) {
    return [...Array(101).keys()].slice(1);
  } else {
    return [...Array(61).keys()].slice(1);
  }
}

export function getDateHour(date) {
  return (
    date.getFullYear() +
    "/" +
    doubleDigit(date.getMonth() + 1) +
    "/" +
    doubleDigit(date.getDate()) +
    " " +
    doubleDigit(date.getHours()) +
    ":" +
    doubleDigit(date.getMinutes())
  );
}
export function getDate(date) {
  return (
    date.getFullYear() +
    "/" +
    doubleDigit(date.getMonth() + 1) +
    "/" +
    doubleDigit(date.getDate())
  );
}
export function showApiError(message) {
  Vue.swal({
    width: 400,
    text: message,
    type: "warning",
  });
}
export function findImage(item) {
  switch (item) {
    case "fa-cloud":
      return require("../../src/assets/cloud-icon.png");
    case "fa-umbrella":
      return require("../../src/assets/rain-icon.png");
    case "fa-sun-o":
      return require("../../src/assets/sun-icon.png");
    default:
      break;
  }
}
